<template>
    <b-card>
        <div class="row" @click="handleCollapseClick">
            <div class="col">
                <span class="float-left"><slot name="title"></slot></span>
                <transition name="fade">
                    <i v-if="collapsed"
                       class="fas fa-angle-down float-right fa-lg">

                    </i>
                    <i v-else
                       class="fas fa-angle-up float-right fa-lg" >
                    </i>
                </transition>
            </div>
        </div>
        <transition name="fade">
            <div v-if="!collapsed" class="row">
                <div class="col">
                    <slot name="body"></slot>
                </div>
            </div>
        </transition>
    </b-card>
</template>

<script>
import { EventBus } from '@/eventBus.js';

export default {
  name: 'CollapsibleCard',
  props: {
      initCollapsed: { type: Boolean, default: false }
  },
  components: {
    
  },
  data: () => {
    return {
      collapsed: false
    }
  },
  mounted() {
      this.collapsed = this.initCollapsed
      EventBus.$on('collapse-all-clicked', () => { this.collapsed = true })
      EventBus.$on('expand-all-clicked', () => { this.collapsed = false })
  },
  computed: {
    
  },
  methods: {
      handleCollapseClick() {
          this.collapsed = !this.collapsed
      }
  }
}
</script>

